import { useEffect, useState, useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom"
import { Button, Box, Icon, Paper, TextField, useTheme, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton, TableFooter, LinearProgress, Autocomplete, CircularProgress, FormGroup, FormControlLabel, Checkbox, Typography, Pagination } from "@mui/material";

import { ISetor, SetorService } from "../../shared/services/api/setor/SetorService";
import { LayoutBaseDePagina } from "../../shared/layouts";
import { Environment } from "../../shared/environment";
import { AlertSnackBar, AutoCompleteDeUnidade } from "../../shared/components";
import { IPaginacao } from "../../shared/services/api/axios-config";
import { DialogConfirm } from "../../shared/components/dialog/DialogConfirm";

export const ListagemDeSetorDesativado: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const theme = useTheme();

  const [alert, setAlert] = useState<{ tipoAlert: string, mensagem: string } | undefined>(undefined);
  const [duracaoAlert, setDuracaoAlert] = useState<number>(Environment.DURACAO_ALERT + 500);

  const [isLoading, setIsLoading] = useState(false);
  const [paginacao, setPaginacao] = useState<IPaginacao>({
    totalCount: 0,
    pageSize: 0,
    currentPage: 0,
    totalPages: 0,
    hasNext: false,
    hasPrevious: false
  });
  const [rows, setRows] = useState<ISetor[]>([]);
  const [idUnidade, setIdUnidade] = useState<number | undefined>(undefined);

  function resetPaginacao() {
    setPaginacao({
      totalCount: 0,
      pageSize: 0,
      currentPage: 0,
      totalPages: 0,
      hasNext: false,
      hasPrevious: false
    });
  }

  const pagina = useMemo(() => {
    return Number(searchParams.get('pagina') || '1');
  }, [searchParams]);

  useEffect(() => {
    handleNewSearch(false);
  }, [idUnidade]);

  useEffect(() => {
    handleNewSearch(true);
  }, [pagina]);

  const handleNewSearch = (newPage: boolean) => {
    setIsLoading(true);

    if (idUnidade === undefined || idUnidade === null || idUnidade == 0) {
      setRows([]);
      resetPaginacao();

      if (localStorage.getItem("idUnidade") !== undefined && localStorage.getItem("idUnidade") !== null && localStorage.getItem("idUnidade") !== "0") 
      {
        setIdUnidade(Number(localStorage.getItem("idUnidade")));
      }
      else
      {
        setIsLoading(false);
      }

    } else {
      if (newPage) {
        SetorService.getByIdUnidade(idUnidade, pagina, false).then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            setAlert({ tipoAlert: "erro", mensagem: result.message });
            setTimeout(() => {
              setAlert(undefined);
            }, duracaoAlert);
          } else {
            setRows(result.setor);
            setPaginacao(result.paginacao);

          }
        });
      } else {
        setSearchParams({ pagina: "1" }, { replace: true })
        setRows([]);
        resetPaginacao();
        SetorService.getByIdUnidade(idUnidade, 1, false).then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            setAlert({ tipoAlert: "erro", mensagem: result.message });
            setTimeout(() => {
              setAlert(undefined);
            }, duracaoAlert);
          } else {
            setRows(result.setor);
            setPaginacao(result.paginacao);

          }
        });
      }
    }

  };

  const handleReable = () => {
    setAbrir(false);
    setIsLoading(true);
    SetorService.toggleEstadoById(idToReable)
      .then(result => {
        setIsLoading(false);
        if (result instanceof Error) {//verificar se deu erro
          setAlert({ tipoAlert: "erro", mensagem: result.message });
          setTimeout(() => {
            setAlert(undefined);
          }, duracaoAlert);
          // alert(result.message);
        } else {
          setRows(oldRows => {
            return [
              ...oldRows.filter(oldRow => oldRow.idSetor !== idToReable),
            ]
          });
          setAlert({ tipoAlert: "sucesso", mensagem: "Setor reativado com sucesso" });
          setTimeout(() => {
            setAlert(undefined);
          }, duracaoAlert);
        }
      });
  }

  const [abrir, setAbrir] = useState(false);
  const [idToReable, setidToReable] = useState<number>(0);

  const handleClickReable = (idUsuario: number) => {
    setAbrir(true);
    setidToReable(idUsuario);
  };

  const handleCancel = () => {
    setAbrir(false);
  };

  return (
    <LayoutBaseDePagina
      titulo="Listagem de setores desativados"
      barraDeFerramentas={null}
    >
      {alert !== undefined && (
        <>
          {alert.tipoAlert === "sucesso" && (
            <AlertSnackBar gravidade="success" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
          {alert.tipoAlert === "erro" && (
            <AlertSnackBar gravidade="error" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
          {alert.tipoAlert === "aviso" && (
            <AlertSnackBar gravidade="warning" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
        </>
      )}

      <DialogConfirm
        AoConfirmar={handleReable}
        titulo={"Dejesa realmente reativar o setor?"}
        texto={"Ao confirmar, o setor e tudo que está contido nele será reativado."}
        abrir={abrir}
        AoCancelar={handleCancel}
      />

      <Box
        component={Paper}
        height={theme.spacing(5)}
        marginX={1}
        padding={1}
        paddingX={2}
        display="flex"
        gap={1}
        alignItems="center"
      >
        <AutoCompleteDeUnidade selectedIdUnidade={selectedIdUnidade => setIdUnidade(selectedIdUnidade)} />

        <Box flex={1} display="flex" justifyContent="end">
          <Typography variant="button" noWrap>
            <Button
              color="primary"
              disableElevation
              variant="contained"
              endIcon={<Icon>add</Icon>}
              onClick={() => navigate('/setor/detalhe/novo')}
            >
              Novo
            </Button>
          </Typography>
        </Box>
      </Box>

      <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: 'auto' }}>
        <Table>
          <TableHead>
            <TableRow>

              <TableCell> Nome </TableCell>
              <TableCell align="center"> Ações </TableCell>

            </TableRow>
          </TableHead>
          <TableBody>

            {rows.map(row => (
              <TableRow key={row.idSetor}>
                <TableCell> {row.nomeSetor} </TableCell>
                <TableCell align="center">
                  <Button
                    color="primary"
                    disableElevation
                    variant="contained"
                    onClick={() => handleClickReable(row.idSetor)}
                  >
                    Reativar
                  </Button>
                </TableCell>
              </TableRow>
            ))}

          </TableBody>

          {paginacao?.totalCount === 0 && !isLoading && (idUnidade !== undefined && idUnidade !== null && idUnidade !== 0) && (
            <caption> {Environment.LISTAGEM_VAZIA} </caption>
          )}
          {idUnidade === undefined || idUnidade === null || idUnidade === 0 && !isLoading && (
            <caption> Selecione uma unidade e uma área para pesquisar </caption>
          )}

          <TableFooter>
            {isLoading && (
              <TableRow>
                <TableCell colSpan={2}>{/* quantas colunas o loading vai ocupar */}
                  <LinearProgress variant='indeterminate' />
                </TableCell>
              </TableRow>
            )}
            {(paginacao?.totalPages > 1 && !isLoading) && (
              <TableRow>
                <TableCell colSpan={2} align="right">
                  <Box flexDirection="row" display="inline-flex">
                    <Typography noWrap marginTop={0.5} >Exibindo {paginacao.hasNext ? paginacao.pageSize * paginacao.currentPage : paginacao.totalCount} de {paginacao?.totalCount}</Typography>
                    <Pagination
                      page={pagina}
                      count={paginacao?.totalPages}
                      onChange={(_, newPage) => setSearchParams({ pagina: newPage.toString() }, { replace: true })}
                    />
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </TableFooter>
        </Table>
      </TableContainer>

    </LayoutBaseDePagina>
  )
}
